import { authService } from '../services/authService.js';
import { element, showMessage } from '../components/publicUi.js';

export class SecurityPage {
  constructor(service = authService, embedded = false) { this.service = service; this.embedded = embedded; }
  render() {
    const page = element('div', this.embedded ? 'security-settings' : 'container page-wrapper');
    this.box = element('section', 'spec-box glow-box');
    this.box.style.maxWidth = '620px'; this.box.style.margin = '0 auto';
    this.box.append(element('h1', 'spec-title', 'Безопасность аккаунта'));
    this.feedback = element('div', 'public-message'); this.feedback.setAttribute('role', 'status');
    const user = this.service.getCurrentUser();
    if (!user) this.box.append(element('p', 'profile-text', 'Для подключения аутентификатора войдите в аккаунт.'));
    else {
      this.box.append(element('p', 'profile-text', user.mfaEnabled ? 'Аутентификатор подключён. Здесь можно заменить приложение и получить новые резервные коды.' : 'Подключите приложение-аутентификатор, чтобы получить доступ к аккаунту.'));
      const form = element('form');
      this.field(form, 'password', 'Текущий пароль', 'password', 'current-password');
      if (user.mfaEnabled) this.field(form, 'factor', 'Код аутентификатора или резервный код', 'text', 'one-time-code');
      this.button(form, user.mfaEnabled ? 'Заменить аутентификатор' : 'Подключить аутентификатор');
      form.addEventListener('submit', e => { e.preventDefault(); void this.perform(form, async () => {
        const result = await this.service.setupMfa({ password: form.elements.password.value, ...(user.mfaEnabled ? { factor: form.elements.factor.value.trim() } : {}) });
        if (!this.disposed) this.showSetup(form, result);
      }); });
      this.box.append(form);
    }
    this.box.append(this.feedback); page.append(this.box); return page;
  }
  field(form, name, label, type = 'text', autocomplete = 'off') {
    const group = element('div', 'auth-form-group'), caption = element('label', 'auth-form-label', label), input = element('input', 'auth-input');
    input.id = `security-${name}`; input.name = name; input.type = type; input.required = true; input.autocomplete = autocomplete; input.maxLength = type === 'password' ? 128 : 64;
    caption.htmlFor = input.id; group.append(caption, input); form.append(group);
  }
  button(form, text) { const b = element('button', 'auth-submit-btn auth-submit-login', text); b.type = 'submit'; form.append(b); }
  async perform(form, action) {
    if (this.busy) return;
    this.busy = true; const controls = [...form.querySelectorAll('input,button')]; controls.forEach(x => { x.disabled = true; });
    showMessage(this.feedback, 'Ожидание ответа сервера…');
    try { await action(); if (!this.disposed) showMessage(this.feedback, ''); }
    catch (e) { if (!this.disposed) showMessage(this.feedback, e.message); }
    finally { this.busy = false; controls.forEach(x => { x.disabled = false; }); form.querySelectorAll('input').forEach(x => { x.value = ''; }); }
  }
  showSetup(oldForm, result) {
    oldForm.remove();
    const area = element('div'); this.sensitive = area;
    area.append(element('p', 'profile-text', 'Отсканируйте QR-код в Google Authenticator, Microsoft Authenticator или другом приложении TOTP. Затем введите код из приложения. QR действует 10 минут.'));
    const qr = element('img'); qr.src = result.qr; qr.alt = 'QR-код подключения аутентификатора'; qr.width = 256; qr.height = 256; qr.style.maxWidth = '100%'; qr.style.height = 'auto'; area.append(qr);
    const details = element('details'), summary = element('summary', '', 'Ввести ключ вручную');
    const secret = element('code', '', result.secret); secret.style.overflowWrap = 'anywhere'; details.append(summary, secret); area.append(details);
    const form = element('form'); this.field(form, 'factor', 'Шестизначный код', 'text', 'one-time-code');
    form.elements.factor.pattern = '[0-9]{6}'; form.elements.factor.inputMode = 'numeric';
    this.button(form, 'Подтвердить подключение'); area.append(form); this.box.insertBefore(area, this.feedback);
    form.addEventListener('submit', e => { e.preventDefault(); void this.perform(form, async () => {
      const confirmed = await this.service.confirmMfa(form.elements.factor.value.trim());
      if (this.disposed) return;
      this.showingRecoveryCodes = true;
      area.replaceChildren(element('h2', 'spec-title', 'Сохраните резервные коды'));
      area.append(element('p', 'profile-text', 'Каждый код действует один раз. Сохраните их в менеджере паролей. Для восстановления забытого пароля без почты нужны резервный код и аутентификатор. При потере телефона войдите с паролем и резервным кодом.'));
      const codes = element('pre', '', confirmed.recoveryCodes.join('\n')); codes.style.whiteSpace = 'pre-wrap'; codes.style.overflowWrap = 'anywhere'; area.append(codes);
      area.append(element('p', 'profile-text', 'Все прежние сессии завершены. После сохранения кодов войдите заново; дождитесь нового кода в приложении.'));
      const done = element('a', 'profile-link', 'Коды сохранены — на главную'); done.href = '#home'; area.append(done);
    }); });
  }
  dispose() { this.disposed = true; this.sensitive?.replaceChildren(); }
}
